function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Row from './Row';
var widths = [97, 100, 94, 90, 98, 95, 98, 40];
function getWidth(i) {
  return "".concat(widths[(i + widths.length) % widths.length], "%");
}
function renderRows(rows) {
  return _toConsumableArray(Array(Number(rows))).map(function (_, i) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(Row, {
        key: i,
        style: {
          width: getWidth(i)
        }
      })
    );
  });
}
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "Text__Wrapper",
  componentId: "so1d3y-0"
})(["width:100%;"]);
var Text = function Text(_ref) {
  var rows = _ref.rows;
  return /*#__PURE__*/React.createElement(Wrapper, null, renderRows(rows));
};
Text.propTypes = {
  rows: PropTypes.number.isRequired
};
export default Text;